Ext.define('SA.controller.ViewObservable', {
    constructor() {
        this.active = false;
        this.observable = new Ext.util.Observable();
    },

    fireEvent(eventName) {
        if (!this.active && eventName !== 'show') {
            return;
        }

        this.observable.fireEvent(eventName);
    },

    on(eventName, cb) {
        this.observable.on(eventName, cb);
    },

    setActive(active) {
        this.active = active;

        active ? this.fireEvent('show') : this.fireEvent('hide');
    }
});